import { render, staticRenderFns } from "./studentProjectLayout.vue?vue&type=template&id=08de024c&scoped=true"
import script from "./studentProjectLayout.vue?vue&type=script&lang=js"
export * from "./studentProjectLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de024c",
  null
  
)

export default component.exports